module.exports = __webpack_public_path__ + "img/Entia-Carreteras-y-edificaciones-13.7942d0ff.webp";